export function getTodayDate() {
    let todayDate = new Date();
    return todayDate.toISOString().slice(0, 19).replace('T', ' ');
}

export function getDateFromValue(date: string) {
    let dateVal = date ? new Date(date) : new Date();
    return dateVal.toISOString().slice(0, 19).replace('T', ' ');
}